import React from 'react';

// @ts-ignore
import Icon from 'assets/images/traps/hub.svg';

interface HubIconProps {
  height?: number;
  width?: number;
}

const HubIcon: React.FC<HubIconProps> = ({ height = 30, width = 30 }) => {
  return <img src={Icon} height={height} width={width} alt="Hub Icon" />;
};

export default HubIcon;
